import { useState, useEffect } from "react";
import { useFormik, FormikProvider } from "formik";
import { axiosInstance } from "../../components/helpers/axiosInstance";
import { FechaCorte } from "./componentes/PagoCaja";
import { CajasDestino } from "../../components/catalogo/Cajas";
import Cajas from "../../components/catalogo/Cajas";
import { validacionesTransferencia } from "./validaciones/validacionesCorte";
import ErrorMessage from "../../components/helpers/ErrorMessage";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import TablaCorte from "../../components/helpers/TablaCorte";
import { useToast } from "../../components/notificaciones/ToastProvider";
import { CajasCompletas } from "../../components/catalogo/Cajas";
import CardCorte from "../../components/helpers/CardCorte";
import TitleTooltip from "../../components/helpers/TitleTooltip";

/**
 * COMPONENTE PRINCIPAL
 * @returns {JSX.Element}
 * @constructor
 */
export default function Transferencias(){
    /**
     * Guardar los datos de tranferecias para la tabla
     */
    const [transferencias, setTransferencias] = useState([]);
    /**
     * NOTÍFICACIONES (toast)
     * @type {undefined}
     * @property setArrayToast
     */
    const toast = useToast();
    /**
     * FECHA
     * @type {Date}
     */
    const date = new Date();
    /**
     * Valores inciales del formulario
     * @type {{fecha: Date, id_caja: number, id_caja_destino: number, monto: string, recibio: string, observaciones: string}}
     */
    const valorInicial = {
        fecha: date,
        id_caja : 100,
        id_caja_destino: 1,
        monto: "",
        recibio: "",
        observaciones: "",
    }

    /**
     * @function onSubmit
     * @param values
     */
    function onSubmit( values ){
        /**
         * Hacer petición al servidor
         */
        axiosInstance.post('/cajas/' + values.id_caja + '/transferencias',
                {
                    id_caja_destino: values.id_caja_destino,
                    monto: values.monto,
                    recibio: values.recibio,
                    observaciones: values.observaciones
                }
            ).then(function (response) {
                /**
                 * Sí el envio se hizo correctamente se muestra dialogo de confirmación,
                 * se guardan los datos en el estado transferencias y devolver formulario a sus valores iniciales
                 */
                setTransferencias([...transferencias, response.data]);

                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id: response.data.id,
                            text: "Se registro el movimiento",
                            color: "success",
                            show: true,
                        }
                    ]
                );
                formik.resetForm();
            }).catch(function (error) {
            /**
             * Notificación : no se pudo eliminar
             */
               toast.setArrayToast(
                   prevState => [
                       ...prevState,
                       {
                           id: error.status,
                           text: error.response.data.errors[0].message,
                           color: "danger",
                           show: true,
                       }
                   ]
               );
            /**
             * Se agrega error al objeto de errores de formik, se muestra en el input correspondiente
             */
               if (error.response.data.errors[0].input === 'id_caja_origen'){
                   formik.setFieldError('id_caja', `${error.response.data.errors[0].details}`);
               } else {
                   formik.setFieldError(`${error.response.data.errors[0].input}`, `${error.response.data.errors[0].details}`);
               }
            });
    }

    /**
     * @const formik neecesarias para el control del formulario
     */
    const formik = useFormik({
        initialValues : valorInicial,
        validationSchema : validacionesTransferencia,
        validateOnMount : true,
        onSubmit,
    });

    return(
        <>
            <style type={'text/css'}>
                {`
                    .rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{
                        color : var(--bs-gray-700)!important;
                    }
                `}
            </style>
            <CardCorte>
                <div className="card card-bordered d-flex flex-row-fluid flex-center">
                    <FormikProvider value={formik}>
                        {
                            /**
                             * Formulario para el registro de transferencia
                             */
                        }
                        <form className="card-body py-15 w-100 px-10" onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className={'col-md-3 mb-7'}>
                                    <FechaCorte formik={formik}></FechaCorte>
                                </div>
                                <div className={'col-md-3'}>
                                    <Cajas formik={formik}></Cajas>
                                    <ErrorMessage name={'id_caja'}></ErrorMessage>
                                </div>
                                <div className={'col-md-3'}>
                                    <CajasDestino formik={formik}></CajasDestino>
                                    <ErrorMessage name={'id_caja_destino'}></ErrorMessage>
                                </div>
                                <div className={'col-md-3'}>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            id="monto"
                                            name="monto"
                                            value={formik.values.monto}
                                            placeholder="Monto"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <label htmlFor="monto" className={"text-gray-700"}>Monto</label>
                                    </div>
                                    <ErrorMessage name={'monto'}></ErrorMessage>
                                </div>
                            </div>
                            <div className="row">
                                <div className={'col-md-3'}>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            id="recibio"
                                            name="recibio"
                                            value={formik.values.recibio}
                                            placeholder="Usuario"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <label htmlFor="recibio" className={"text-gray-700"}>Recibio dinero</label>
                                    </div>
                                    <ErrorMessage name={'recibio'}></ErrorMessage>
                                </div>
                                <div className={'col-md-9 mb-7'}>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            id="observaciones"
                                            name="observaciones"
                                            value={formik.values.observaciones}
                                            placeholder="Total de búsquedas"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <label htmlFor="observaciones" className={"text-gray-700"}>Observaciones</label>
                                    </div>
                                </div>
                            </div>
                            <div className={'d-flex justify-content-end mt-2'}>
                                <button className={'btn btn-primary'} type={'submit'} disabled={Object.keys(formik.errors).length > 0}>Enviar</button>
                            </div>
                        </form>
                        {
                            /**
                             * FIN : Formulario para el registro de transferencia
                             */
                        }
                    </FormikProvider>
                </div>
                <div className="card card-bordered d-flex flex-row-fluid flex-center mt-5">
                    {
                        /**
                         * Consultar transferencias
                         */
                    }
                    <TablaTransferencias transferencias={transferencias} setTransferencias={setTransferencias} ></TablaTransferencias>
                    {
                        /**
                         * FIN : Consultar transferencias
                         */
                    }
                </div>
            </CardCorte>
    </>);
}

//////////// FIN COMPONENTE : PRINCIPAL ////////////

/**
 * COMPONENTE : TABLA DE TRANSFERENCIAS
 * @param transferencias
 * @param setTransferencias
 * @returns {JSX.Element}
 * @constructor
 */
function TablaTransferencias({
    transferencias,
    setTransferencias,
}) {
    /**
     * Cambiar libreria dayjs a español
     */
    dayjs.locale(es);
    /**
     * Notificaciones
     * @type {undefined}
     */
    const toast = useToast();
    /**
     * Datos del usuario en sesión
     */
    const user = JSON.parse(sessionStorage.getItem('user'));
    /**
     * Controlar cuando cambia el select de caja
     * @type {{caja_tabla: number}}
     */
    const valorInicial = {
        caja_tabla: 100,
    };
    /**
     * @function onSubmit enviar datos a formulario
     * @param values
     */
    const onSubmit = (values) => { console.log(values); };
    /**
     * @const formik
     */
    const formik = useFormik({
        initialValues: valorInicial,
        onSubmit,
    });
    /**
     * Extraer datos de las tranferencias
     */
    useEffect(() => {
        axiosInstance.get("/cajas/" + formik.values.caja_tabla + "/transferencias")
            .then((res) => {
                setTransferencias(res.data);
            }).catch((error) => console.log(error));
    }, [formik.values, setTransferencias]);

    /**
     * @function cajasString
     * @param idcaja
     * @returns {string} nombre completo de la caja
     */
    function cajasString(idcaja){
        switch(idcaja){
            case 1:
                return "FIDUCIA BANAMEX";
            case 2:
                return "FIDUCIA SANTANDER";
            case 100:
                return "MATRIZ";
            case 101:
                return "OFICINA-GDL";
            case 102:
                return "MODULO-GDL";
            default:
                return "OFICINA-CMX";
        }
    }

    /**
     * @function deleteRow elimina el registro de un tranferencia en la tabla
     * @param id
     */
    function deleteRow(id){
        axiosInstance.delete(`/cajas/${formik.values.caja_tabla}/transferencias/${id}`)
            .then((res) => {
               if (res.status === 204) {
                   /**
                    * Cuando se hizo el borrado en el servidor se elimina del arreglo "tranferencias"
                    * y se muestra la notificación de confirmación
                    */
                   setTransferencias(transferencias.filter((t) => t.id !== id));
                   toast.setArrayToast(prevState => [
                       ...prevState,
                       {
                           id: id,
                           text: 'Movimiento eliminado',
                           color: 'success',
                           show: true,
                       }
                   ])
               }
            }).catch((error) => {
                if (error.status === 404) {
                    /**
                     * Sí hubo algún error se muestra la notificación de error
                     */
                    toast.setArrayToast(prevState => [
                        ...prevState,
                        {
                            id: id,
                            text: "Usuario sin acceso, el administrador del sistema será notificado",
                            color: 'danger',
                            show: true,
                        }
                    ])
                } else {
                    /**
                     * Sí la API no responde se muestra también una notificacion de error
                     */
                    toast.setArrayToast(prevState => [
                        ...prevState,
                        {
                            id: id,
                            text: error.message,
                            color: 'danger',
                            show: true,
                        }
                    ])
                }
        })
    }

    /**
     * @param t.id
     * @param t.fecha
     * @param t.id_caja_origen
     * @param t.id_caja_destiono
     * @param t.transfirio
     * @param t.confirmo
     * @param t.monto
     * @param t.observaciones
     * @param t.caja_origen
     * @param t.caja_destino
     * */
  return (
    <div className={"card-body py-15 w-100 px-10"}>
        <div className="row mb-2">
            <div className={'col-md-2'}>
                {
                    /**
                     * SELECT DE CAJA
                     */
                }
                <CajasCompletas formik={formik}></CajasCompletas>
                {
                    /**
                     * FIN : SELECT DE CAJA
                     */
                }
            </div>
        </div>
        <TablaCorte data={transferencias}>
            <thead>
            <tr className={'fw-bold text-muted text-start pb-5 text-uppercase'}>
                <th className={'ps-2'}>Fecha</th>
                <th>Transfirio</th>
                <th>Recibio</th>
                <th>Cuenta origen</th>
                <th>Cuenta destino</th>
                <th>Observaciones</th>
                <th>Monto</th>
            </tr>
            </thead>
            <tbody>
            {
                /**
                 * FILA DE REGISTRO DE TRANSFERENCIAS
                 */
            }
            {
                transferencias && transferencias.toReversed().map((t) => {
                    return (
                        <tr key={t.id} className={'text-uppercase text-gray-900 fw-semibold text-start'}>
                            <td className={'ps-2 align-content-center'}>{dayjs(t.fecha).format('MMM DD, YYYY')}</td>
                            <td className={'align-content-center'}>{t.transfirio}</td>
                            <td className={'align-content-center'}>{t.recibio}</td>
                            <td className={'align-content-center'}>{t.caja_origen ?? cajasString(t.id_caja_origen)}</td>
                            <td className={'align-content-center'}>{cajasString(t.caja_destino) ?? cajasString(t.id_caja_destino)}</td>
                            <td className={'align-content-center'}>{t.observaciones}</td>
                            <td className={'align-content-center'}>{t.monto}</td>
                            {
                                (user && user.usuario.usuario === t.transfirio) && <td className={'d-flex justify-content-end'}>
                                    <TitleTooltip title="Borrar" placement={'top'}>
                                        <button type={'button'} onClick={() => deleteRow(t.id)} className="btn btn-light-danger btn-icon btn-sm">
                                            <i className="ki-solid ki-trash fs-5"></i>
                                        </button>
                                    </TitleTooltip>
                                </td>
                            }
                        </tr>
                    )
                })
            }
            {
                /**
                 * FIN : FILA DE REGISTRO DE TRANSFERENCIAS
                 */
            }
            </tbody>
        </TablaCorte>
    </div>
  );
}

/////////// FIN COMPONENTE : TABLA DE TRANSFERNCIAS ///////////
